import script from "./InternalServiceList.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalServiceList.vue?vue&type=script&setup=true&lang=js"

import "./InternalServiceList.vue?vue&type=style&index=0&id=726058fd&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726058fd"]])

export default __exports__